import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/download-report.svg";
var DownloadReportSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DownloadReportSolid_default as default
};
